export default __webpack_public_path__ + "static/media/office-3-bhs.ab788a22.mp4";